// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__Q72Eb","title":"ClientReferral_title__3fwhJ","itemText":"ClientReferral_itemText__20KLc"};